import { api } from './client';
import type { EmployeeNotificationDTO } from '@shared/types';

export async function getNotifications(limit = 50, offset = 0): Promise<EmployeeNotificationDTO[]> {
  const { data } = await api.get('/employee-notifications', { params: { limit, offset } });
  return data;
}

export async function getUnreadCount(): Promise<number> {
  const { data } = await api.get('/employee-notifications/unread-count');
  return data.count;
}

export async function markRead(id: string): Promise<void> {
  await api.patch(`/employee-notifications/${id}/read`);
}

export async function markAllRead(): Promise<void> {
  await api.post('/employee-notifications/mark-all-read');
}

export async function acknowledgeNotification(id: string): Promise<{ success: boolean }> {
  const { data } = await api.post(`/employee-notifications/${id}/acknowledge`);
  return data;
}
